const UNITS = ['B', 'KB', 'MB', 'GB'];

export const convertFileSize = (size: number): string => {
  let value = size;
  let unitIndex = 0;

  while (value >= 1000 && unitIndex < UNITS.length - 1) {
    value /= 1000;
    unitIndex++;
  }

  return `${value.toFixed(2)} ${UNITS[unitIndex]}`;
};
